module.exports = __webpack_public_path__ + "2f2ece8757bd3fd64254e0d74aa2c86a.svg";